window.arjoCheckboxGroupModule =
  window.arjoCheckboxGroupModule ||
  (() => {
    const state = {
      isInitialized: false,
      elements: {},
    };
    const selector = '.arjo-m-checkbox-group';
    const eventNamePrefix = 'checkboxGroupChange';

    const setUp = () => {
      const els = document.querySelectorAll(selector);

      [].forEach.call(els, (el) => {
        const checkboxGroupId = el.dataset.checkboxGroupId;
        if (!checkboxGroupId) return;
        state.elements[checkboxGroupId] = (() => {
          const innerState = {
            currentValues: [],
          };
          const activeCheckboxes = [...el.querySelectorAll('input[type=checkbox][checked]')];
          innerState.currentValues = [...activeCheckboxes.map((cb) => cb.value)];
          const changeHandler = (e) => {
            const value = e.target.value;
            const isDefault = e.target.checked;
            if (isDefault) {
              innerState.currentValues = [].concat(value).concat(...innerState.currentValues);
            } else {
              innerState.currentValues = [].concat([...innerState.currentValues].filter((x) => x !== value));
            }

            const customEvent = new CustomEvent(`${eventNamePrefix}:${checkboxGroupId}`, {
              detail: {
                values: [...innerState.currentValues],
              },
            });
            window.dispatchEvent(customEvent);
          };
          el.addEventListener('change', changeHandler);

          return {
            get currentValues() {
              return innerState.currentValues;
            },
          };
        })();
      });
    };
    const init = () => {
      if (state.isInitialized) return;
      setUp();
      state.isInitialized = true;
    };

    const getElement = (id) => state.elements[id];
    return { init, getElement };
  })();

window.addEventListener('load', window.arjoCheckboxGroupModule.init);
